// 0: 本地开发环境 localhost
// 1: 预发布环境 stg
// 2: 生产环境 prod
const ENV_TYPE = 2;

// 根据环境确定协议
const PROTOCOL = ENV_TYPE === 0 ? "http" : "https";

// LeanCloud 服务器地址
const SERVER_URL = [
  "localhost:8080", // 本地开发
  "stg-pre.easylink.cc", // 预发布
  "easylink.cc", // 生产
][ENV_TYPE];

// ECS 自建服务器地址
const SERVICE_URL = `${PROTOCOL}://${
  [
    "192.168.1.3:8080", // 本地开发
    "stg-service.easylink.cc", // 预发布
    "service.easylink.cc", // 生产
  ][ENV_TYPE]
}`;

// 是否为开发环境
const isDev = ENV_TYPE !== 2;

export { isDev, SERVER_URL, SERVICE_URL };
